import adjustmentIcon from '@trqk/components/assets/icons/currency_dollar_white.svg';
import composerIcon from '@trqk/components/assets/icons/midi_white.svg';
import cueSheetIcon from '@trqk/components/assets/icons/film_white.svg';
import musicUserGenreIcon from '@trqk/components/assets/icons/video_camera_2_white.svg';
import proxyIcon from '@trqk/components/assets/icons/duplicate_white.svg';
import publisherIcon from '@trqk/components/assets/icons/media_library_2_white.svg';
import settlementIcon from '@trqk/components/assets/icons/scale_white.svg';
import subpublisherIcon from '@trqk/components/assets/icons/media_library_1_white.svg';
import trackIcon from '@trqk/components/assets/icons/music_2_white.svg';

export const summarizeDirectedTreeConfig = {
    maxNodeCount: 200,
    minTotalTrackEarnings: 1,
    minNodeEarnings: 0.01,
    defaultEntityType: 'track' as ProDirectedTreeNodeEntity,
    iconMap: {
        adjustment: adjustmentIcon,
        composer: composerIcon,
        cue_sheet: cueSheetIcon,
        music_user_genre: musicUserGenreIcon,
        proxy: proxyIcon,
        publisher: publisherIcon,
        settlement: settlementIcon,
        subpublisher: subpublisherIcon,
        track: trackIcon,
        unknown: publisherIcon,
    },
};
